/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FiltroDTO
 */
export interface FiltroDTO {
    /**
     * 
     * @type {string}
     * @memberof FiltroDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FiltroDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof FiltroDTO
     */
    espressione?: string;
}

/**
 * Check if a given object implements the FiltroDTO interface.
 */
export function instanceOfFiltroDTO(value: object): value is FiltroDTO {
    return true;
}

export function FiltroDTOFromJSON(json: any): FiltroDTO {
    return FiltroDTOFromJSONTyped(json, false);
}

export function FiltroDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FiltroDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'espressione': json['espressione'] == null ? undefined : json['espressione'],
    };
}

export function FiltroDTOToJSON(value?: FiltroDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'nome': value['nome'],
        'espressione': value['espressione'],
    };
}

